<script setup lang="ts">
defineProps<{
  onClick?: () => void
  className?: string
  disabled?: boolean
  iconOnly?: boolean
  destructive?: boolean
}>()
</script>
<template>
  <button
    class="flex items-center justify-center cursor-pointer bg-button rounded-full gap-1.25"
    :class="[
      className,
      iconOnly ? 'p-3' : 'py-3 px-5',
      destructive ? 'bg-danger' : 'bg-button',
      disabled ? 'opacity-50 cursor-not-allowed' : '',
    ]"
    @click="onClick"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>
